
import { useSecurityEvents } from './useSecurityEvents';
import { useComplianceViolations } from './useComplianceViolations';
import { useSecurityLogging } from './useSecurityLogging';

// Re-export types for backward compatibility
export type { SecurityEvent } from './useSecurityEvents';
export type { ComplianceViolation } from './useComplianceViolations';

// Combined hook for backward compatibility
export const useSecurityCompliance = () => {
  const {
    loading: eventsLoading,
    securityEvents,
    fetchSecurityEvents,
    resolveSecurityEvent,
  } = useSecurityEvents();

  const {
    loading: violationsLoading,
    violations,
    fetchComplianceViolations,
    updateViolationStatus,
  } = useComplianceViolations();

  const {
    logSecurityEvent,
    detectSuspiciousActivity,
  } = useSecurityLogging();

  return {
    loading: eventsLoading || violationsLoading,
    securityEvents,
    violations,
    logSecurityEvent,
    detectSuspiciousActivity,
    fetchSecurityEvents,
    fetchComplianceViolations,
    resolveSecurityEvent,
    updateViolationStatus,
  };
};
